<div class="operation-popover">
  <span class="operation-popover-title">{{ title }}</span>
  <span class="operation-popover-text">{{ text }}</span>
  <div class="operation-popover-actions">
    <fw-button color="danger" test-id="cancel-operation-button" variant="outline" (click)="onCancelClick.emit()">{{
      cancelTitle
    }}</fw-button>
    <fw-button color="danger" test-id="submit-operation-button" (click)="onSubmitClick.emit()">{{
      submitTitle
    }}</fw-button>
  </div>
</div>
